import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { getPunchRecords } from "../../services/dataService";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import FilterComponent from "../pages/FilterComponent";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { getSecureItem } from "../../services/SecureStorage";

function PunchRecords() {
  const departmentIds = getSecureItem("DepartmentId") || "";
  const DepartmentId = departmentIds.split(",")[0] || null;
  const isAdmin = getSecureItem("IsAdmin");
  const [locationCache, setLocationCache] = useState({});

  const [punchRecords, setPunchRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dates, setDates] = useState({
    FromDate: new Date().toISOString().split("T")[0],
    ToDate: new Date().toISOString().split("T")[0],
  });
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [DataFilter, setDataFilter] = useState([]);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);
  };

  const fetchPunchRecords = async () => {
    try {
      setLoading(true);
      const result = await getPunchRecords(dates);
      const details =
        isAdmin == 1
          ? result.data.data
          : result.data.data.filter((El) => El.DepartmentID == DepartmentId);
      setPunchRecords(details || []);
      setDataFilter(details || []);

   
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPunchRecords();
  }, []);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDates((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const filteredItems = DataFilter.filter((item) => {
    const searchTextv = searchText.toLowerCase();

    return (
      item.EmployeeName?.toLowerCase().includes(searchTextv) ||
      item.ShiftName?.toLowerCase().includes(searchTextv) ||
      item.EmpCode?.toString().toLowerCase().includes(searchTextv) ||
      item.RECORDDATE?.toString().toLowerCase().includes(searchTextv)
    );
  });

  const handleFetchClick = () => {
    fetchPunchRecords();
  };

  const formatTime = (dateTimeString) => {
    if (!dateTimeString) return "-";
    try {
      const date = new Date(dateTimeString);
      return date.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: "UTC",
      });
    } catch (error) {
      return "Invalid Date";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return "Invalid Date";
    }
  };

  const columnsFilter = [
    {
      name: "Sl No",
      cell: (row, index, page) => {
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Employee",
      selector: (row) => row.EmployeeName || "-",
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.EmpCode || "-",
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => formaatDate(row.RECORDDATE),
      sortable: true,
    },
    {
      name: "Shift",
      selector: (row) => row.ShiftName || "-",
      sortable: true,
    },
    {
      name: "Shift In",
      selector: (row) => formatTime(row.INTIME),
      sortable: true,
    },
    {
      name: "Shift Out",
      selector: (row) => formatTime(row.OUTTIME),
      sortable: true,
    },
    {
      name: "Punch In",
      selector: (row) => formatTime(row.PUNCHIN),
      sortable: true,
    },

    {
      name: "Punch Out",
      selector: (row) => formatTime(row.PUNCHOUT),
      sortable: true,
    },

  {
  name: "Location",
  grow: 0,
  width: "260px",
  selector: (row) => {
    if (!row.MobilePunchLocation) return "-";

    // If not mobile punch
    if (row?.PunchIP !== "1000") {
      return "PunchingDevice";
    }

    // Otherwise, use the already readable address from DB
    return row.MobilePunchLocation;
  },
  sortable: false,
  cell: (row) => {
    if (!row.PunchIP) return "-";

    // If not mobile punch
    if (row?.PunchIP !== "1000") {
      return <span>PunchingDevice</span>;
    }

    // Otherwise, display the readable address directly
    return (
      <span className="text-sm break-words whitespace-normal">
        {row.MobilePunchLocation}
      </span>
    );
  },
},

  ];

 
  // Common date formatting function for both Excel and PDF
  function formaatDate(date) {
    if (!date) return "-";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // Helper function to get location for reports
  const getLocationForReport = (coordinates, ipAddress) => {
    if (!coordinates) return "-";

    if (ipAddress !== "1000") {
      return "PunchingDevice";
    }

    const [lat, lng] = coordinates.split(",").map(Number);
    const key = `${lat},${lng}`;
    return locationCache[key] || "PunchingDevice"; // Fallback to PunchingDevice if not found
  };

  const handleExportExcel = () => {
    const fromDate = formaatDate(dates.FromDate);
    const toDate = formaatDate(dates.ToDate);

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.aoa_to_sheet([]);

    XLSX.utils.sheet_add_aoa(
      worksheet,
      [[`Punch Records From ${fromDate} to ${toDate}`]],
      { origin: "A1" }
    );

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    const mergeRange = { s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }; // Extended for location columns
    if (!worksheet["!merges"]) worksheet["!merges"] = [];
    worksheet["!merges"].push(mergeRange);

    const headers = [
      "Sl No",
      "Employee Name",
      "Code",
      "Date",
      "Shift",
      "Shift In",
      "Shift Out",
      "Punch In",
      "Location IN",
      "Punch Out",
      "Location OUT",
    ];

    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A3" });

    const dataRows = filteredItems.map((item, index) => [
      index + 1,
      item.EmployeeName || "-",
      item.EmpCode || "-",
      formaatDate(item.RECORDDATE),
      item.ShiftName || "-",
      formatTime(item.INTIME),
      formatTime(item.OUTTIME),
      formatTime(item.PUNCHIN),
      getLocationForReport(item.MobilePunchLocation, item.PunchIP),
      formatTime(item.PUNCHOUT),
      item.LocationOut, item.IpAddressOut,
    ]);

    XLSX.utils.sheet_add_aoa(worksheet, dataRows, { origin: "A4" });

    const colWidths = [
      { wch: 6 }, // Sl No
      { wch: 25 }, // Employee Name
      { wch: 10 }, // Code
      { wch: 12 }, // Date
      { wch: 10 }, // Shift
      { wch: 10 }, // Shift In
      { wch: 10 }, // Shift Out
      { wch: 10 }, // Punch In
      { wch: 30 }, // Location IN
      { wch: 10 }, // Punch Out
      { wch: 30 }, // Location OUT
    ];
    worksheet["!cols"] = colWidths;

    XLSX.utils.book_append_sheet(workbook, worksheet, "Punch Records");
    XLSX.writeFile(workbook, `Punch_Records_On_${fromDate}_to_${toDate}.xlsx`);
  };

  const handleDownloadPDF = (dates) => {

    const fromDate = formaatDate(dates.FromDate);
    const toDate = formaatDate(dates.ToDate);

    // Create A3 landscape PDF for better column spacing
    const doc = new jsPDF("landscape", "mm", "a3");

    doc.setProperties({
      title: `Punch Records ${fromDate} to ${toDate}`,
      subject: "Attendance Report",
      creator: "Attendance System",
    });

    // Get page dimensions
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 20;

    // Title
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text("Punch Records Report", pageWidth / 2, 25, { align: "center" });

    // Subtitle
    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.text(`Period: ${fromDate} to ${toDate}`, pageWidth / 2, 35, {
      align: "center",
    });

    // Table headers
    const tableColumn = [
      "Sl No",
      "Employee Name",
      "Code",
      "Date",
      "Shift",
      "Shift In",
      "Shift Out",
      "Punch In",
      "Punch Out",
      "Location",
    ];

    // Prepare table rows
    const tableRows = [];
   filteredItems.forEach((item, index) => {
  tableRows.push([
    index + 1,
    item.EmployeeName || "-",
    item.EmpCode || "-",
    formaatDate(item.RECORDDATE),
    item.ShiftName || "-",
    formatTime(item.INTIME),
    formatTime(item.OUTTIME),
    formatTime(item.PUNCHIN),
    formatTime(item.PUNCHOUT),
    item.PunchIP === "1000" ? item.MobilePunchLocation : "Punching Device",
  ]);
});

    // Create simple table
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 45,
      margin: { left: margin, right: margin },
      styles: {
        fontSize: 9,
        cellPadding: 3,
        overflow: "linebreak",
        halign: "left",
        valign: "middle",
        textColor: [0, 0, 0],
        fillColor: [255, 255, 255], // White background
        lineWidth: 0.2,
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [255, 255, 255], // White header background
        textColor: [0, 0, 0], // Black text
        fontStyle: "bold",
        fontSize: 10,
        halign: "center",
      },
      bodyStyles: {
        fillColor: [255, 255, 255], // White body
        textColor: [0, 0, 0],
      },
      alternateRowStyles: {
        fillColor: [255, 255, 255], // Disable alternating color
      },
      columnStyles: {
        0: { cellWidth: 20, halign: "center" }, // Sl No
        1: { cellWidth: 50, halign: "left" }, // Employee Name
        2: { cellWidth: 30, halign: "center" }, // Code
        3: { cellWidth: 25, halign: "center" }, // Date
        4: { cellWidth: 35, halign: "center" }, // Shift
        5: { cellWidth: 25, halign: "center" }, // Shift In
        6: { cellWidth: 25, halign: "center" }, // Shift Out
        7: { cellWidth: 25, halign: "center" }, // Punch In
        8: { cellWidth: 25, halign: "center" }, // Punch Out
        9: { cellWidth: 110, halign: "left", overflow: "linebreak" }, // Location
      },

      didDrawPage: function (data) {
        // Header line
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.3);
        doc.line(margin, 40, pageWidth - margin, 40);

        // Footer
        doc.setFontSize(9);
        doc.setTextColor(80, 80, 80);

        // Page number
        const pageNum = `Page ${doc.internal.getNumberOfPages()}`;
        doc.text(pageNum, pageWidth / 2, pageHeight - 10, { align: "center" });

        // Generation timestamp
        const now = new Date().toLocaleString("en-IN", {
          timeZone: "Asia/Kolkata",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        doc.text(`Generated: ${now}`, margin, pageHeight - 10);

        // Total records
        const totalRecords = `Total Records: ${filteredItems.length}`;
        doc.text(totalRecords, pageWidth - margin, pageHeight - 10, {
          align: "right",
        });

        // Footer line
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.3);
        doc.line(margin, pageHeight - 15, pageWidth - margin, pageHeight - 15);
      },
    });

    // Save file
    doc.save(`Punch_Records_${fromDate}_to_${toDate}.pdf`);
  };

  const subHeaderComponentMemo = React.useMemo(() => {
    return (
      <div className="w-full flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-4">
        <input
          type="text"
          placeholder="Search..."
          className="form-control w-full md:w-64 px-3 py-2 border rounded"
          value={searchText}
        />
      </div>
    );
  }, [searchText]);

  return (
    <div>
      <Breadcrumb title="Punch Records" />

      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="flex flex-wrap gap-4 mb-4">
          <div>
            <label className="block mb-2 text-sm font-medium">From Date</label>
            <input
              type="date"
              name="FromDate"
              className="w-full p-2 border rounded"
              value={dates.FromDate}
              onChange={handleDateChange}
            />
          </div>
          <div>
            <label className="block mb-2 text-sm font-medium">To Date</label>
            <input
              type="date"
              name="ToDate"
              className="w-full p-2 border rounded"
              value={dates.ToDate}
              onChange={handleDateChange}
            />
          </div>
          <div className="flex items-end">
            <button
              className="btn btn-primary w-full"
              onClick={handleFetchClick}
              disabled={loading}
            >
              {loading ? "Loading..." : "Fetch Records"}
            </button>
          </div>
          <div className="flex items-end gap-2">
            <button
              className="bg-sky rounded-[4px] px-4 py-2"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px] mx-auto" />
            </button>

            {filteredItems.length > 0 && (
              <>
                <button
                  onClick={() => handleExportExcel()}
                  className="bg-green-600 text-white px-4 py-2 rounded-[4px]"
                >
                  Export Excel
                </button>
                <button
                  onClick={() => {
                    handleDownloadPDF(dates);
                  }}
                  className="bg-red-600 text-white px-4 py-2 rounded-[4px]"
                >
                  Download PDF
                </button>
              </>
            )}
          </div>
        </div>

        {isFilterVisible && (
          <FilterComponent
            columns={columnsFilter}
            data={punchRecords}
            onFilter={handleFilter}
          />
        )}

        <ReactDataTable
          columns={columnsFilter}
          data={filteredItems}
          pagination
          paginationResetDefaultPage={resetPaginationToggle}
          subHeader
          progressPending={loading}
          persistTableHead
          responsive
          highlightOnHover
          noDataComponent="No punch records found"
        />
      </div>
    </div>
  );
}

export default PunchRecords;
